<template>
  <BaseAction>
    <SecondaryButton @click.native="openDialog" textColor="#a63232">
      <inline-svg :src="require('@/assets/svg/close_red.svg')" width="20" />
      Cancel Interview
    </SecondaryButton>
    <CancelInterviewDialog
      v-if="isDialogOpen"
      :isOpen="isDialogOpen"
      @close="closeDialog"
    />
  </BaseAction>
</template>

<script>
import CancelInterviewDialog from "@/views/interviews/dialogs/CancelInterviewDialog";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";
import InlineSvg from "vue-inline-svg";

export default {
  name: "CancelInterviewAction",
  components: {
    BaseAction,
    SecondaryButton,
    CancelInterviewDialog,
    InlineSvg
  },
  data() {
    return {
      isDialogOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isDialogOpen = true;
    },
    closeDialog() {
      this.isDialogOpen = false;
    }
  }
};
</script>
